import * as atatus from 'atatus-spa';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import App from './App';
import 'antd/dist/reset.css';
import './index.css';
import './components/SubscriptionRestrictionFeedback.css';
import './assets/font/style.css'
import store from "./store"
import AxiosInterceptor from './utils/axiosConfig'

atatus.config('8f3285c20a5a40b8a4b14fd3919478dd').install();

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <AxiosInterceptor>
      <App />
    </AxiosInterceptor>
  </Provider>
);
